import React, { useEffect } from "react";
import s from "./CategoryPage.module.scss";
import Header from "../../components/Header/Header";
import FullFilter from "../../components/FullFilter/FullFilter";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useParams } from "react-router-dom";
import CategoryCarItem from "../../components/CategoryCarItem/CategoryCarItem";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useSelector } from "react-redux";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import SpareItem from "../../components/SpareItem/SpareItem";

const CategoryPage = () => {
  const { width } = useWindowDimensions();
  const cars = useSelector((state) => state.cars.cars);
  const params = useParams();
  const newCars = useSelector((state) => state.cars.newCars);
  const spares = useSelector((state) => state.cars.spares);

  return (
    <div>
      <div className={s.category_page}>
        {width > 800 ? (
          <div className={s.left}>
            {/* <img src='/images/left.png' className={s.leftImg} /> */}
          </div>
        ) : null}
        <div className={s.main}>
          {width > 1000 ? <div className={s.top}>Реклама</div> : null}
          <div className={s.main_content}>
            {width > 1200 ? <Header /> : <MobileHeader />}
            <h3 className={s.h2}>
              {params.id === "new" && "Новые авто из салонов"}
              {params.id === "4" ? "Запчасти" : cars[0]?.vehicle_type?.name}
            </h3>
            <FullFilter />
            {params.id === "new" ? (
              <div className={s.cars_list}>
                {Array.isArray(newCars) &&
                  cars.length > 0 &&
                  cars?.map((el) => <CategoryCarItem car={el} />)}
              </div>
            ) : params.id === "4" ? (
              <div className={s.cars_list}>
                {Array.isArray(spares) &&
                  spares.length > 0 &&
                  spares?.map((el) => <SpareItem spare={el} />)}
              </div>
            ) : (
              <div className={s.cars_list}>
                {Array.isArray(cars) &&
                  cars.length > 0 &&
                  cars?.map((el) => <CategoryCarItem car={el} />)}
              </div>
            )}
          </div>
        </div>
        {width > 800 ? (
          <div className={s.right}>
            {/* <img src={"/images/right.png"} className={s.rightImg} /> */}
          </div>
        ) : null}
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};
// };

export default CategoryPage;
